import axios from "axios";

export const state = {
    moneytransfers: [],
};

export const getters = {
    moneytransfers: state => state.moneytransfers,
};

export const mutations = {
    setMoneyTransfers(state, newValue) {
        state.moneytransfers = newValue
    },
};

export const actions = {
    fetchMoneyTransfers({ commit }) {
        axios.get('/moneytransfers').then(res => {
            commit('setMoneyTransfers', res.data.transfers)
        })
    },
};
